import Circle from './Circle';
import Rectangle from './Rectangle';
import Star from './Star';

export { Circle, Rectangle, Star };
